/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeSecretsCreateComputeSecret } from "../../funcs/computeSecretsCreateComputeSecret.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateComputeSecretRequest$inboundSchema,
};

export const tool$computeSecretsCreateComputeSecret: ToolDefinition<
  typeof args
> = {
  name: "compute-secrets-create-compute-secret",
  description: `Create a secret`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeSecretsCreateComputeSecret(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
